(function () {
  const finder = document.querySelector('.ld-project-finder');
  if (!finder) return;

  const collectionUrl = finder.dataset.collectionUrl || '/collections/patterns';
  const inspireUrl = finder.dataset.inspireUrl || '/collections/patterns';

  const filters = {
    craft: 'filter.p.product_type',
    patternFor: 'filter.p.m.custom.pattern_for',
    patternType: 'filter.p.m.custom.pattern_type',
    yarnWeight: 'filter.p.m.custom.yarn_weight',
    chestSize: 'filter.p.m.custom.chest_size'
  };

  const iconJson = document.querySelector('[data-ldpf-icons]');
  let iconUrls = {};

  if (iconJson) {
    try {
      iconUrls = JSON.parse(iconJson.textContent);
    } catch (error) {
      iconUrls = {};
    }
  }

  finder.querySelectorAll('[data-icon]').forEach((button) => {
    const iconUrl = iconUrls[button.dataset.icon];

    if (iconUrl) {
      button.insertAdjacentHTML(
        'afterbegin',
        `<img class="ldpf__icon-img" src="${iconUrl}" alt="" loading="lazy">`
      );
    }
  });

  const projectHeadings = {
    clothing: 'Which item of clothing would you like to make?',
    accessories: 'Which accessory would you like to make?',
    blankets: 'What type of blanket project are you looking for?',
    'home-furnishings': 'Which home furnishing are you looking for?',
    toys: 'What toy or gift project are you looking for?'
  };

  const recipientCategories = {
    'Premature Babies': ['clothing', 'accessories', 'blankets'],
    Babies: ['clothing', 'accessories', 'blankets'],
    Toddlers: ['clothing', 'accessories', 'blankets'],
    Children: ['clothing', 'accessories', 'blankets'],
    Adults: ['clothing', 'accessories', 'blankets'],
    Home: ['blankets', 'home-furnishings'],
    Christmas: ['clothing', 'accessories', 'home-furnishings'],
    Pets: ['toys']
  };

  const patternLogic = {
    Blankets: {
      categories: ['blankets'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children', 'Adults', 'Home'],
      askChestSize: false
    },
    Bonnets: {
      categories: ['accessories'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers'],
      askChestSize: false
    },
    Bootees: {
      categories: ['accessories'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children'],
      askChestSize: false
    },
    Cardigans: {
      categories: ['clothing'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: true
    },
    Coats: {
      categories: ['clothing'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: true
    },
    Dresses: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children'],
      askChestSize: true
    },
    Hoodies: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: true
    },
    Jackets: {
      categories: ['clothing'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: true
    },
    'Jumpers / Sweaters': {
      categories: ['clothing'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children', 'Adults', 'Christmas'],
      askChestSize: true
    },
    'Onesies & Dungarees': {
      categories: ['clothing'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children'],
      askChestSize: true
    },
    Ponchos: {
      categories: ['clothing'],
      recipients: ['Children', 'Adults'],
      askChestSize: true
    },
    Rompers: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children'],
      askChestSize: true
    },
    Shorts: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children'],
      askChestSize: true
    },
    Skirts: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children'],
      askChestSize: true
    },
    Slipovers: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: true
    },
    Tops: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: true
    },
    'Trousers / Leggings': {
      categories: ['clothing'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children'],
      askChestSize: true
    },
    Waistcoats: {
      categories: ['clothing'],
      recipients: ['Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: true
    },
    'Gloves / Mittens / Handwarmers': {
      categories: ['accessories'],
      recipients: ['Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: false
    },
    Hats: {
      categories: ['accessories'],
      recipients: ['Premature Babies', 'Babies', 'Toddlers', 'Children', 'Adults', 'Christmas'],
      askChestSize: false
    },
    Mittens: {
      categories: ['accessories'],
      recipients: ['Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: false
    },
    'Scarves / Cowls': {
      categories: ['accessories'],
      recipients: ['Children', 'Adults'],
      askChestSize: false
    },
    Socks: {
      categories: ['accessories'],
      recipients: ['Babies', 'Toddlers', 'Children', 'Adults'],
      askChestSize: false
    },
    Cushions: {
      categories: ['home-furnishings'],
      recipients: ['Home'],
      askChestSize: false
    },
    Decorations: {
      categories: ['home-furnishings'],
      recipients: ['Home', 'Christmas'],
      askChestSize: false
    },
    'Pet Clothing': {
      categories: ['toys'],
      recipients: ['Pets'],
      askChestSize: false
    },
    Toys: {
      categories: ['toys'],
      recipients: ['Toys'],
      askChestSize: false
    }
  };

  const answers = {};
  const labels = {};
  const history = [];
  let currentStep = 'craft';

  const stepOrder = ['craft', 'recipient', 'category', 'project', 'size', 'yarn'];
  const steps = finder.querySelectorAll('[data-step]');
  const progress = finder.querySelectorAll('.ldpf__progress span');
  const chips = finder.querySelector('.ldpf__chips');
  const backButton = finder.querySelector('.ldpf__back');
  const restartButton = finder.querySelector('.ldpf__restart');
  const projectHeading = finder.querySelector('[data-project-heading]');
  const recipientHeading = finder.querySelector('[data-recipient-heading]');

  function getLogic() {
    return patternLogic[answers.patternType] || {
      categories: [],
      recipients: [],
      askChestSize: false
    };
  }

  function updateChips() {
    const order = ['craft', 'patternFor', 'projectGroup', 'patternType', 'chestSize', 'yarnWeight'];

    chips.innerHTML = order
      .filter((key) => labels[key])
      .map((key) => `<span class="ldpf__chip">${labels[key]}</span>`)
      .join('');
  }

  function showStep(stepName) {
    currentStep = stepName;

    steps.forEach((step) => {
      step.classList.toggle('is-active', step.dataset.step === stepName);
    });

    const stepIndex = stepOrder.indexOf(stepName);
    progress.forEach((dot, index) => {
      dot.classList.toggle('is-active', index <= stepIndex);
    });

    backButton.hidden = history.length === 0;
    restartButton.hidden = history.length === 0;

    updateChips();
  }

  function goToStep(stepName) {
    history.push(currentStep);
    showStep(stepName);
  }

  function updateRecipientHeading() {
    if (!recipientHeading) return;

    if (answers.craft === 'Crochet Pattern') {
      recipientHeading.textContent = 'Who are you crocheting for?';
      return;
    }

    if (answers.craft === 'Knitting Pattern') {
      recipientHeading.textContent = 'Who are you knitting for?';
      return;
    }

    recipientHeading.textContent = 'Who is this project for?';
  }

  function updateCategoryButtons() {
    const allowedCategories = recipientCategories[answers.patternFor] || [
      'clothing',
      'accessories',
      'blankets',
      'home-furnishings',
      'toys'
    ];

    finder.querySelectorAll('[data-category]').forEach((button) => {
      button.hidden = !allowedCategories.includes(button.dataset.category);
    });
  }

  function showProjectGroup(group) {
    finder.querySelectorAll('[data-project-group]').forEach((groupEl) => {
      groupEl.hidden = groupEl.dataset.projectGroup !== group;
    });

    if (projectHeading && projectHeadings[group]) {
      projectHeading.textContent = projectHeadings[group];
    }
  }

  function updateProjectButtons() {
    finder.querySelectorAll('[data-step="project"] [data-answer="patternType"]').forEach((button) => {
      const logic = patternLogic[button.dataset.value];

      if (!logic) {
        button.hidden = true;
        return;
      }

      const matchesCategory = logic.categories.includes(answers.projectGroup);
      const matchesRecipient = !answers.patternFor || logic.recipients.includes(answers.patternFor);

      button.hidden = !(matchesCategory && matchesRecipient);
    });
  }

  function shouldAskSize() {
    return getLogic().askChestSize === true;
  }

  function nextAfterProject() {
    if (shouldAskSize()) {
      goToStep('size');
      return;
    }

    goToStep('yarn');
  }

  function buildResultsUrl() {
    const params = new URLSearchParams();

    Object.keys(answers).forEach((key) => {
      if (!filters[key] || !answers[key]) return;
      params.append(filters[key], answers[key]);
    });

    params.set('sort_by', 'best-selling');
    params.set('utm_source', 'project_finder');
    params.set('utm_medium', 'site');
    params.set('utm_campaign', 'find_your_next_project');

    return `${collectionUrl}?${params.toString()}`;
  }

  function goToResults() {
    window.location.href = buildResultsUrl();
  }

  function goToInspireMe() {
    const baseUrl = inspireUrl || '/collections/patterns';
    const separator = baseUrl.includes('?') ? '&' : '?';

    window.location.href =
      baseUrl +
      separator +
      'sort_by=created-descending&utm_source=project_finder&utm_medium=site&utm_campaign=inspire_me';
  }

  finder.querySelectorAll('[data-answer]').forEach((button) => {
    button.addEventListener('click', function () {
      const key = this.dataset.answer;

      answers[key] = this.dataset.value;
      labels[key] = this.dataset.label || this.textContent.trim();

      if (currentStep === 'craft') {
        updateRecipientHeading();
        goToStep('recipient');
        return;
      }

      if (currentStep === 'recipient') {
        updateCategoryButtons();
        goToStep('category');
        return;
      }

      if (currentStep === 'project') {
        nextAfterProject();
        return;
      }

      if (currentStep === 'size') {
        goToStep('yarn');
        return;
      }

      if (currentStep === 'yarn') {
        goToResults();
      }
    });
  });

  finder.querySelectorAll('[data-category]').forEach((button) => {
    button.addEventListener('click', function () {
      answers.projectGroup = this.dataset.category;
      labels.projectGroup = this.querySelector('strong')
        ? this.querySelector('strong').textContent.trim()
        : this.textContent.trim();

      showProjectGroup(this.dataset.category);
      updateProjectButtons();
      goToStep('project');
    });
  });

  const showAllRecipientsButton = finder.querySelector('[data-show-all-recipients]');
  if (showAllRecipientsButton) {
    showAllRecipientsButton.addEventListener('click', function () {
      delete answers.patternFor;
      delete labels.patternFor;

      updateCategoryButtons();
      goToStep('category');
    });
  }

  const showAllSizesButton = finder.querySelector('[data-show-all-sizes]');
  if (showAllSizesButton) {
    showAllSizesButton.addEventListener('click', function () {
      delete answers.chestSize;
      delete labels.chestSize;
      goToStep('yarn');
    });
  }

  const anyYarnButton = finder.querySelector('[data-any-yarn]');
  if (anyYarnButton) {
    anyYarnButton.addEventListener('click', function () {
      delete answers.yarnWeight;
      delete labels.yarnWeight;
      goToResults();
    });
  }

  const inspireButton = finder.querySelector('[data-inspire]');
  if (inspireButton) {
    inspireButton.addEventListener('click', goToInspireMe);
  }

  if (backButton) {
    backButton.addEventListener('click', function () {
      const previous = history.pop();
      if (previous) showStep(previous);
    });
  }

  if (restartButton) {
    restartButton.addEventListener('click', function () {
      Object.keys(answers).forEach((key) => delete answers[key]);
      Object.keys(labels).forEach((key) => delete labels[key]);
      history.length = 0;
      showStep('craft');
    });
  }

  showStep('craft');
})();